import { useEffect, useState } from "react";

/** Valor com atraso: pra filtro/busca que entra em queryKey, evita 1 request
 *  por tecla digitada (o input usa o valor cru; a query usa o debounced). */
export function useDebounce<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
